import * as R from 'ramda';
// constants
import * as GC from '../constants';
//////////////////////////////////////////////////

const getGuidFromObject = (item = {}) => R.path([GC.FIELD_GUID], item);

const getPrimaryReferenceValueFromObject = (item = {}) => R.path(
  [GC.FIELD_PRIMARY_REFERENCE_VALUE],
  item,
);

const getIdFromObject = (item = {}) => R.path([GC.FIELD_ID], item);

const getLocationFromObject = (item = {}) => R.path([GC.FIELD_LOCATION], item);

const getIdOrGuidFromObject = (item = {}) => R.pathOr(
  R.path([GC.FIELD_GUID], item),
  [GC.FIELD_ID],
  item,
);

const getDataFromObject = (item = {}) => R.path(['data'], item);

const getDisplayedValueFromObject = (item = {}) => R.path([GC.FIELD_DISPLAYED_VALUE], item);

const getDropdownOptionGuidFromObject = (item = {}) => R.path([GC.FIELD_DROPDOWN_OPTION_GUID], item);

const getBranchGuidFromObject = (item = {}) => R.path([GC.FIELD_BRANCH_GUID], item);

const getValueFromObject = (item = {}) => R.path([GC.FIELD_VALUE], item);

const getNameFromObject = (item = {}) => R.path([GC.FIELD_NAME], item);

const getVersionFromObject = (item = {}) => R.path([GC.FIELD_VERSION], item);

const getPropFromObject = (propName, item = {}) => R.path([propName], item);

const getPropFromObject2 = (propName, item = {}, defaultValue = null) => R.pathOr(
  defaultValue,
  [propName],
  item,
);

const getPropFromObjectsLeft = (propName, obj1, obj2) => {
  const prop1 = getPropFromObject(propName, obj1);
  const prop2 = getPropFromObject(propName, obj2);

  return R.or(prop1, prop2);
};

const getEventTargetValue = (event) => R.path(['target', 'value'], event);

const getEventTargetName = (event) => R.path(['target', 'name'], event);

const getEventTargetChecked = (event) => R.path(['target', 'checked'], event);

export {
  getIdFromObject,
  getDataFromObject,
  getGuidFromObject,
  getPropFromObject,
  getNameFromObject,
  getValueFromObject,
  getPropFromObject2,
  getEventTargetName,
  getEventTargetValue,
  getVersionFromObject,
  getEventTargetChecked,
  getLocationFromObject,
  getIdOrGuidFromObject,
  getPropFromObjectsLeft,
  getBranchGuidFromObject,
  getDisplayedValueFromObject,
  getDropdownOptionGuidFromObject,
  getPrimaryReferenceValueFromObject,
};
